import { render } from "./LyPay.vue?vue&type=template&id=4dd65352&scoped=true"
import script from "./LyPay.vue?vue&type=script&lang=js"
export * from "./LyPay.vue?vue&type=script&lang=js"

import "./LyPay.vue?vue&type=style&index=0&id=4dd65352&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dd65352"]])

export default __exports__